var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "password",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.682,
    height: 16,
    viewBox: "0 0 11.682 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9371",
    "data-name": "Path 9371",
    d: "M172.383,295.078a.469.469,0,0,1-.469-.469v-1.942a.469.469,0,0,1,.938,0v1.942A.469.469,0,0,1,172.383,295.078Zm0,0",
    transform: "translate(-166.542 -283.068)",
    fill: "#39BE9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9372",
    "data-name": "Path 9372",
    d: "M.469,5.141H2.687V2.858A3.02,3.02,0,0,1,5.841,0,3.02,3.02,0,0,1,8.995,2.858V5.141h2.219a.469.469,0,0,1,.469.469V11.6A4.4,4.4,0,0,1,7.287,16H4.395A4.4,4.4,0,0,1,0,11.6V5.61a.469.469,0,0,1,.469-.469ZM8.057,2.858A2.087,2.087,0,0,0,5.841.937,2.087,2.087,0,0,0,3.625,2.858V5.141H8.057ZM.937,11.6a3.461,3.461,0,0,0,3.457,3.457H7.287A3.461,3.461,0,0,0,10.745,11.6V6.079H.937Zm0,0",
    transform: "translate(0 0)",
    fill: "#39BE9D",
    stroke: "#39BE9D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.d171692e73546b7bd288d20403ab5d22.svg";
export { ForwardRef as ReactComponent };